var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Programme_Icon",
    "data-name": "Programme Icon",
    transform: "translate(4072 -4498)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(-4072 4530) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "handshake_24dp_FILL1_wght400_GRAD0_opsz24",
    d: "M92.12-818.4a1.161,1.161,0,0,1-.855-.345,1.161,1.161,0,0,1-.345-.855,1.168,1.168,0,0,1,.09-.435,1.2,1.2,0,0,1,.27-.405l5.55-5.55-.87-.87-5.52,5.55a1.246,1.246,0,0,1-.39.27,1.13,1.13,0,0,1-.45.09,1.161,1.161,0,0,1-.855-.345,1.161,1.161,0,0,1-.345-.855,1.184,1.184,0,0,1,.09-.495,1.187,1.187,0,0,1,.24-.345l5.55-5.55-.84-.84-5.55,5.52a1.246,1.246,0,0,1-.39.27,1.209,1.209,0,0,1-.48.09,1.151,1.151,0,0,1-.84-.36,1.151,1.151,0,0,1-.36-.84,1.13,1.13,0,0,1,.09-.45,1.246,1.246,0,0,1,.27-.39l5.55-5.55-.87-.84-5.52,5.55a1.134,1.134,0,0,1-.36.24,1.293,1.293,0,0,1-.51.09,1.161,1.161,0,0,1-.855-.345,1.161,1.161,0,0,1-.345-.855,1.13,1.13,0,0,1,.09-.45,1.246,1.246,0,0,1,.27-.39l6.69-6.69,4.5,4.53a2.491,2.491,0,0,0,.78.525,2.248,2.248,0,0,0,.9.2,2.379,2.379,0,0,0,1.68-.675,2.26,2.26,0,0,0,.72-1.725,2.746,2.746,0,0,0-.15-.87,2.154,2.154,0,0,0-.54-.84l-5.37-5.37a3.651,3.651,0,0,1,1.14-.735A3.336,3.336,0,0,1,95.24-840a3.963,3.963,0,0,1,1.44.255,3.446,3.446,0,0,1,1.2.795l5.07,5.1a3.446,3.446,0,0,1,.795,1.2,4.229,4.229,0,0,1,.255,1.53,3.006,3.006,0,0,1-.27,1.215,3.677,3.677,0,0,1-.78,1.125l-9.99,10.02a1.182,1.182,0,0,1-.42.3A1.33,1.33,0,0,1,92.12-818.4ZM81.83-828l-.78-.78a3.221,3.221,0,0,1-.78-1.14A3.61,3.61,0,0,1,80-831.3a3.439,3.439,0,0,1,.3-1.44,3.736,3.736,0,0,1,.75-1.11l5.07-5.1a3.627,3.627,0,0,1,1.14-.765A3.241,3.241,0,0,1,88.55-840a4.267,4.267,0,0,1,1.44.225,3.371,3.371,0,0,1,1.23.825l6.15,6.15a1.245,1.245,0,0,1,.27.39,1.13,1.13,0,0,1,.09.45,1.151,1.151,0,0,1-.36.84,1.151,1.151,0,0,1-.84.36,1.175,1.175,0,0,1-.45-.075,1.275,1.275,0,0,1-.39-.285l-5.4-5.34Z",
    transform: "translate(-4148 5343)",
    fill: "#0469ac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramme);
export default __webpack_public_path__ + "static/media/programme.5de09a463d7f354b634760eef0d837cb.svg";
export { ForwardRef as ReactComponent };